<template>
  <div class="index">
    <div class="nav1">
      <div class="tit1">会员价格配置</div>
    </div>
    <div class="nav2">
      <div class="myForm">
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <el-col :span="20">
              <el-form-item label="周会员价格：">
                <el-input-number v-model="weekPrice" :min="1" :max="1000" :step="1"></el-input-number>
                <span class="price-unit">元</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="月会员价格：">
                <el-input-number v-model="monthPrice" :min="1" :max="5000" :step="1"></el-input-number>
                <span class="price-unit">元</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="年会员价格：">
                <el-input-number v-model="yearPrice" :min="1" :max="10000" :step="1"></el-input-number>
                <span class="price-unit">元</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button style="margin-top:10px" icon="el-icon-s-promotion" size="small" type="primary" @click="submitForm">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        prices: ""
      },
      weekPrice: 58,
      monthPrice: 98,
      yearPrice: 888
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await this.$api.crudselectonebyid({
        table: 'systems',
        id: 1,
        columns: 'prices'
      });
      // 注意res有两个data才可以取到值
      if (res.data && res.data.data && res.data.data.prices) {
        this.ruleForm.prices = res.data.data.prices;
        // 解析prices字段值，格式为 0:58,1:98,2:888
        const priceItems = this.ruleForm.prices.split(',');
        priceItems.forEach(item => {
          const [type, price] = item.split(':');
          if (type === '0') this.weekPrice = parseInt(price);
          if (type === '1') this.monthPrice = parseInt(price);
          if (type === '2') this.yearPrice = parseInt(price);
        });
      } else {
        // 默认值
        this.weekPrice = 58;
        this.monthPrice = 98;
        this.yearPrice = 888;
      }
    },
    // 提交
    async submitForm() {
      // 组装prices字段值
      const prices = `0:${this.weekPrice},1:${this.monthPrice},2:${this.yearPrice}`;
      
      const res = await this.$api.crudupdatebyid({
        table: 'systems',
        id: 1,
        values: {
          prices: prices
        }
      });
      
      if (res.data && res.data.result == 1) {
        this.$message({
          message: res.data.msg || '保存成功',
          type: "success"
        });
        this.getData();
      } else {
        this.$message.error(res.data ? res.data.msg : '保存失败');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.index {}

.nav1 {
  margin: 0 -18px;
  background-color: #fff;
  padding: 20px 32px 0 40px;

  .tit1 {
    color: #17233d;
    font-weight: 500;
    font-size: 20px;
    padding-bottom: 20px;
  }
}

.nav2 {
  margin: 18px 0;
  background: #fff;
  border-radius: 6px;
  padding: 24px;

  .myForm {
    ::v-deep .el-form-item__label {
      font-size: 12px;
    }

    ::v-deep .el-form-item {
      margin-right: 30px;
      margin-bottom: 20px;
    }
  }
}

.price-unit {
  margin-left: 10px;
  font-size: 14px;
}
</style> 